module.exports = __webpack_public_path__ + "img/vipevent_gender_icon@2x.e4299db4.png";